import router from '@/router'
import jwt_decode from "jwt-decode";

const state = {
  jwtToken: localStorage.getItem('jwtToken'),
  userData: JSON.parse(localStorage.getItem('userData')),
  error: null
}

const mutations = {
  LOGIN_SUCCESS (state, data) {
    state.jwtToken = data.jwtToken
    state.userData = data.userData
    state.error = null
  },

  LOGIN_FAILURE (state, error) {
    state.jwtToken = null
    state.userData = null
    state.error = error
  },

  LOGOUT (state) {
    state.jwtToken = null
    state.userData = null
    state.error = null
  }
}

const actions = {
  login (context, token) {
    if (token) {
      let userData = jwt_decode(token);
      localStorage.setItem('jwtToken', token);
      localStorage.setItem('userData', JSON.stringify(userData));
      context.commit('LOGIN_SUCCESS', { jwtToken: token, userData})
    } else {
      context.commit('LOGIN_FAILURE', 'Authorization fail')
    }
  },

  logout (context) {
    localStorage.removeItem('jwtToken')
    localStorage.removeItem('userData')
    context.commit('LOGOUT')
    router.push('/')
  }
}

const getters = {
  jwtToken: state => {
    return state.jwtToken
  },

  currentUser: state => {
    return state.userData
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
